module.exports = __webpack_public_path__ + "static/media/four_marker.caa77c81.svg";